module.exports = __webpack_public_path__ + "img/15-01_Informing Others.8059a43d.svg";